/** @module analyses/getLinkStatistics */

var getLinks = require( "./getLinks" );

/**
 * Checks a text for anchors and returns the number found.
 *
 * @param {object} paper The paper object containing text, keyword and url.
 * @returns {number} The number of links found in the text.
 */
module.exports = function( paper ) {
	var anchors = getLinks( paper );

	return anchors.length;
};



// WEBPACK FOOTER //
// ./node_modules/yoastseo/js/researches/countLinks.js